import apiClient from "./client.js";

export async function fetchStatusPages() {
  const res = await apiClient.get("/status-pages");
  return res.data.data;
}

export async function fetchStatusPage(id) {
  const res = await apiClient.get(`/status-pages/${id}`);
  return res.data.data;
}

export async function createStatusPage(data) {
  const res = await apiClient.post("/status-pages", data);
  return res.data.data;
}

export async function updateStatusPage(id, data) {
  const res = await apiClient.patch(`/status-pages/${id}`, data);
  return res.data.data;
}

export async function createStatusPageMessage(statusPageId, data) {
  const res = await apiClient.post(`/status-pages/${statusPageId}/messages`, data);
  return res.data.data;
}

export async function updateStatusPageMessage(statusPageId, messageId, data) {
  const res = await apiClient.patch(
    `/status-pages/${statusPageId}/messages/${messageId}`,
    data
  );
  return res.data.data;
}

export async function fetchStatusPageSubscribers(statusPageId) {
  const res = await apiClient.get(`/status-pages/${statusPageId}/subscribers`);
  return res.data.data;
}
